import { render } from "./HanaRibbonBackdrop.vue?vue&type=template&id=2c89ddc7&scoped=true"
const script = {}

import "./HanaRibbonBackdrop.vue?vue&type=style&index=0&id=2c89ddc7&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c89ddc7"]])

export default __exports__